var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "molstar-structure-panel" }, [
    _c(
      "div",
      { ref: "structurepanel", staticClass: "molstar-structure-wrapper" },
      [
        _vm._t("overlay"),
        _vm._v(" "),
        _c("StructureViewerTooltip", {
          attrs: {
            attach: ".molstar-structure-panel",
            isFullscreen: _vm.isFullscreen,
          },
        }),
        _vm._v(" "),
        _c(
          "StructureViewerToolbar",
          _vm._b(
            {
              attrs: {
                isFullscreen: _vm.isFullscreen,
                isSpinning: _vm.isSpinning,
              },
              on: {
                makeImage: _vm.handleMakeImage,
                makeCIF: _vm.handleMakeCIF,
                resetView: _vm.handleResetView,
                toggleFullscreen: _vm.handleToggleFullscreen,
                toggleSpin: _vm.handleToggleSpin,
                toggleQuery: function ($event) {
                  return _vm.$emit("toggleQuery")
                },
                toggleTarget: function ($event) {
                  return _vm.$emit("toggleTarget")
                },
                toggleArrows: function ($event) {
                  return _vm.$emit("toggleArrows")
                },
                "toggle-structure-separation": function ($event) {
                  return _vm.$emit("toggle-structure-separation")
                },
              },
            },
            "StructureViewerToolbar",
            _vm.toolbar,
            false
          )
        ),
        _vm._v(" "),
        _c(
          "div",
          { ref: "viewport", staticClass: "molstar-structure-viewer" },
          [
            _c("canvas", {
              ref: "canvas",
              staticClass: "molstar-structure-canvas",
              attrs: { "aria-hidden": "true" },
            }),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }